import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/twitter-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "m-subscribe-backdrop" }, null, -1)
const _hoisted_2 = { class: "m-subscribe-modal-container" }
const _hoisted_3 = { class: "m-subscribe-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Never miss a drop", -1)
const _hoisted_5 = { class: "m-subscribe-close-button" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "m-subscribe-form-error"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "m-subscribe-privacy" }, [
  /*#__PURE__*/_createTextVNode(" By subscribing you agree to our "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://manifoldxyz.notion.site/Privacy-Policy-bfc497773ea048d08dfa96644cb48adc"
  }, "Privacy Policy"),
  /*#__PURE__*/_createTextVNode(" and to receive periodic updates. ")
], -1)
const _hoisted_11 = { class: "m-subscribe-actions-container" }
const _hoisted_12 = {
  type: "submit",
  class: "m-subscribe-action"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "spinner"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "m-subscribe-success-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "m-subscribe-success-circle" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      "stroke-width": "1.5",
      stroke: "currentColor",
      class: "w-6 h-6"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M4.5 12.75l6 6 9-13.5"
      })
    ])
  ])
], -1)
const _hoisted_17 = { class: "m-subscribe-tweet" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "twitter logo"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Share your support", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "m-subscribe-button-loading"
}
const _hoisted_23 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "m-subscribe-bell"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Subscribe ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogDescription = _resolveComponent("DialogDescription")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.DATA_WIDGET_VALUE + ' manifold')
  }, [
    _createVNode(_component_TransitionRoot, { show: _ctx.isModalOpen }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          class: "m-widget-subscribe",
          onClose: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "m-subscribe-backdrop-enter-animation",
              "enter-from": "m-subscribe-backdrop-enter-from-animation",
              "enter-to": "m-subscribe-backdrop-enter-to-animation",
              leave: "m-subscribe-backdrop-leave-animation",
              "leave-from": "m-subscribe-backdrop-leave-from-animation",
              "leave-to": "m-subscribe-backdrop-leave-to-animation"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "m-subscribe-modal-enter-animation",
              "enter-from": "m-subscribe-modal-enter-from-animation",
              "enter-to": "m-subscribe-modal-enter-to-animation",
              leave: "m-subscribe-modal-leave-animation",
              "leave-from": "m-subscribe-modal-leave-from-animation",
              "leave-to": "m-subscribe-modal-leave-to-animation"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_DialogPanel, { class: "m-subscribe-modal" }, {
                    default: _withCtx(() => [
                      _createElementVNode("header", _hoisted_3, [
                        _createVNode(_component_DialogTitle, { class: "m-subscribe-title" }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                          }, _hoisted_7)
                        ])
                      ]),
                      _createVNode(_Transition, { mode: "out-in" }, {
                        default: _withCtx(() => [
                          (_ctx.state === 'subscribe')
                            ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                                _createVNode(_component_DialogDescription, { class: "m-subscribe-description" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Add your email to subscribe to " + _toDisplayString(_ctx.ensOrWallet), 1)
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("form", {
                                  class: "m-subscribe-form",
                                  onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.subscribe && _ctx.subscribe(...args)), ["prevent"]))
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    ref: "emailInput",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                                    class: "m-subscribe-email-input",
                                    name: "email",
                                    type: "email",
                                    required: "",
                                    placeholder: "example@manifold.xyz"
                                  }, null, 512), [
                                    [_vModelText, _ctx.email]
                                  ]),
                                  (_ctx.error)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.error), 1))
                                    : _createCommentVNode("", true),
                                  _hoisted_10,
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("button", _hoisted_12, [
                                      (!_ctx.loading)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Subscribe to " + _toDisplayString(_ctx.ensOrWallet), 1))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_14))
                                    ])
                                  ])
                                ], 32)
                              ]))
                            : (_openBlock(), _createElementBlock("section", _hoisted_15, [
                                _hoisted_16,
                                _createVNode(_component_DialogDescription, { class: "m-subscribe-description m-subscribe-description--success" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" You are now subscribed to " + _toDisplayString(_ctx.ensOrWallet) + " ", 1),
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("a", {
                                        class: "m-subscribe-tweet-button",
                                        href: `https://twitter.com/intent/tweet?text=${_ctx.tweetText}`,
                                        target: "_blank"
                                      }, _hoisted_21, 8, _hoisted_18)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("button", {
      ref: "openModalButton",
      type: "button",
      class: "m-subscribe-button",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("i", _hoisted_22))
        : (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_25)),
      _hoisted_26
    ], 512)
  ], 2))
}